import { SEARCH_CAMPAIGN_CREATION_WIZARD_STEP_PATHS, SEARCH_AD_GROUP_CREATION_WIZARD_STEP_PATHS } from '../steps/step-utils';

export const ACTIVITY_NAME = {
  [SEARCH_CAMPAIGN_CREATION_WIZARD_STEP_PATHS.CAMPAIGN_SETTINGS]: 'CampaignSettingsStep',
  [SEARCH_CAMPAIGN_CREATION_WIZARD_STEP_PATHS.KEYWORDS]: 'KeywordsStep',
  [SEARCH_CAMPAIGN_CREATION_WIZARD_STEP_PATHS.CREATE_AD]: 'CreateAdStep',
  [SEARCH_CAMPAIGN_CREATION_WIZARD_STEP_PATHS.ADD_MORE_ASSETS]: 'AddMoreAssetsStep',
  [SEARCH_CAMPAIGN_CREATION_WIZARD_STEP_PATHS.BUDGET_AND_BIDS]: 'BudgetAndBidsStep',
  [SEARCH_CAMPAIGN_CREATION_WIZARD_STEP_PATHS.SUMMARY]: 'SummaryStep',

  [SEARCH_AD_GROUP_CREATION_WIZARD_STEP_PATHS.AD_GROUP_SETTINGS]: 'AdGroupSettingsStep',
  [SEARCH_AD_GROUP_CREATION_WIZARD_STEP_PATHS.KEYWORDS]: 'KeywordsStep',
  [SEARCH_AD_GROUP_CREATION_WIZARD_STEP_PATHS.CREATE_AD]: 'CreateAdStep',
  [SEARCH_AD_GROUP_CREATION_WIZARD_STEP_PATHS.CREATE_DSA_AD]: 'CreateDsaAdStep',
  [SEARCH_AD_GROUP_CREATION_WIZARD_STEP_PATHS.BID_AND_TARGET]: 'BidAndTargetStep',
  [SEARCH_AD_GROUP_CREATION_WIZARD_STEP_PATHS.BID_AND_TARGET_DSA]: 'BidAndTargetDsaStep',
};
